<template>
  <div class="slider__card">
    <img src="~@/assets/images/slider-item-imgs/ico225.svg" alt="ico225.svg">
    <div class="text-container">
      <text-string label-id="txt1435"/>
    </div>
  </div>
</template>

<script>
  export default {
    name: "storage-instruction-three",
  }
</script>
